import React from "react";
import {
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
  Dimensions
} from "react-native";
import { Surface, Avatar } from "react-native-paper";
import { Text, Styles, Config } from "./../../components/UI-Components";
import { MaterialAndTestSeriesComponent } from "./../../components";
// import Icons from "react-native-vector-icons/FontAwesome";
// import { 480 } from './../Utils';
import RatingsComponent from "./ratingComponent";
import { connect } from "react-redux";
import {
  getLessonPlanner,
  clearLessonPlannerData,
  getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark
} from "./../../store/actions";
import { lessonPlannerInfo } from "./../../store/selector";
import { COURSE_MATERIAL, LESSON_PLANNER_SCREEN } from './../../store/constants/bookmarkConstants';
import { FOR_COURSE } from "./../../store/constants";
import { bookmarksSelector } from './../../store/selectors';
// import OfflineHandler from './../OfflineHandler';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import AdsScreen from './../Ads';
// import { deviceHeight } from './../Utils/index';
import PlayArrow from  '@material-ui/icons/PlayArrow';
import PictureAsPdf from  '@material-ui/icons/PictureAsPdf';
import Description from  '@material-ui/icons/Description';
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";

import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import Header from "./../../components/Header/index";
const videoIcon = require('./../../assets/assets_png/lessonVideo.png');
const pdfIcon = require('./../../assets/assets_png/Pdf.png');
const rightArrow = require('./../../assets/assets_png/rightArrow.png');
const lock = require('./../../assets/assets_png/lock.png');
const testIcon = require('./../../assets/assets_png/test.png');
const epubIcon = require('./../../assets/assets_png/epub.png');

const { width, height } = Dimensions.get("window");



const avatarImg = require("./../../assets/avatar.jpeg");

const ContentCounterComponent = ({ type, count, content }) => {
  return (
    <>
      {content[type] && (
        <View style={styles.contentCountWrapper}>
               <Image 
                      source={type === 'video' ?
                       videoIcon 
                       : type ==='pdf'?
                        pdfIcon : 
                        type ==='epub'
                        ?
                        epubIcon
                        :
                        type === 'test'
                        ?
                        testIcon
                        :null

                    } 
                     style={styles.contentIcon}
                     />
          {/* <Icons name={type === 'video' ? 'play' : type ==='pdf'? 'file' : 'file'} size={12} color={'#bbdefb'} style={styles.contentIcon} /> */}
          <Text style={styles.contentCount}>{count} <Text style={{fontWeight: '600'}}>{` ${type === 'epub' ? 'material' : type} `}</Text></Text>
            <Text>{count > 1 ? "'s" : ""}</Text>
        </View>
      )}
    </>
  );
};

const LessonComponent = ({
  navigation,
  title,
  pdfCount,
  videoCount,
  epubCount,
  isUserPaid,
  isFree,
  lessonPlannerId,
  history,
  mentor_name,
     addBookMarks, deleteBookMark, lesson,
    bookmarkId,testCount,
    isBookmarked,facultyInfo={},
}) => {
  // console.log(mentor_name, "ASflkasjkfn")
  // let _title = [];
  //   const divide = title.split(":").join(",");
  //   _title.push(divide.split(","));
  const showAll = videoCount === 0 && pdfCount === 0 && epubCount === 0 && testCount === 0;
  const content = {
    video: showAll || videoCount > 0,
    pdf: showAll || pdfCount > 0,
    epub: showAll || epubCount > 0,
    test: showAll || testCount > 0 
  };

  return (
    
      <div className='lesson_content' 
         onClick={() =>
          history.push("/courseMaterial", {
            lessonPlannerId: lessonPlannerId,
            mentor_name ,
            title: title, 
                  facultyInfo: {
                      ...facultyInfo,
                      cometId: mentor_name                
                  }
          })
        }
       >
        <View style={styles.lessonHeader}>
        <View style={{
          flexDirection: 'row', 
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',}}>
              <View style={{width: '80%'}}>
                <Text style={{...styles.headerText, marginRight: 10, fontWeight: '600' }}
                elipsizeMode='tail'
                numberOfLines={2}
                >{title}</Text>
              </View>
                        
          </View>
          <View style={styles.contentCounter}>
            <ContentCounterComponent
              type="video"
              count={videoCount}
              content={content}
            />
            <ContentCounterComponent
              type="pdf"
              count={pdfCount}
              content={content}
            />
            <ContentCounterComponent
              type="epub"
              count={epubCount}
              content={content}
            />
            <ContentCounterComponent
              type="test"
              count={testCount}
              content={content}
            />
          </View>
        </View>
        
        <View style={{flexDirection: 'row', alignItems: 'center'}}>
            {
                !isUserPaid || !isFree &&
                    <Image source={lock} size={18} style={{ marginHorizontal: 4}}/>   
            }
            <Image source={rightArrow} size={18} />
        </View>
      </div>

  );
};

class LessonPlanner extends React.Component {
  state = {
    description: null,
  };

 
  componentDidMount() {
    this.getLessonPlannerData();
  }

  componentWillUnmount() {
    this.props.clearLessonPlannerData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.courseInfo !== this.props.courseInfo) {
      if (this.props.courseInfo) {
        const { description, course_name } = this.props.courseInfo;
        // if(description){
        //     this.props.navigation.setParams({

        //          description: description,
        //          title: course_name
        //         })
        // }
      }
    }
    if(prevProps.addBookMarkResponse !== this.props.addBookMarkResponse) {
      if(this.props.addBookMarkResponse) {
          this.props.getBookMarks();
      }
  }
  }

  getLessonPlannerData = () => {
    const { location } = this.props;
    const { state = {} } = location || {};
    console.log(state);
    const { courseId, examId, examName } = state;

    

    this.setState({
      examId: examId,
      examName: examName,
      courseId: courseId
    });

    this.props.getLessonPlanner(courseId);
  };

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };
  addBookMark = (item) => {   
    const data = {
        content_id: item && item.id,
        content_name: 'titleId',
        content_url: "null",
        screen_name: LESSON_PLANNER_SCREEN,
        type: COURSE_MATERIAL,
        image_url: '',
        description: null,
        title: item && item.lesson_planner_name,
        
    }
    this.props.addBookMark(data)
    
}
 makePayment = (transactionType, id, price) => {
  this.props.history.push("/Payment", {
    paymentInfo: {
      transactionType: transactionType,
      courseId: id,
      price: price,
      
    },
    examId: this.state.examId,
  });
 } 
  render() {
    const {
      isUserPaid,
      facultyInfo = {},
      lessonPlanners = [],
      courseInfo = {},
      isFree,
      facultyId,
      facultyAvatar,
      facultyFirstName,
      courseMaterial={},
      mentor_name
    } = this.props;
    const {course_image, actual_price, is_discounted, discount_price, course_name, id, description, admin_rating, app_store_product_id, duration } = courseInfo || {};
    const { profile_pic } = facultyInfo || {}
    const { ids ={}, bookmarks=[] } = courseMaterial || {};
    return (
      <>
       <Header
        title="Lesson Planner"
        headerRight
        headerRightClick={() => this.props.history.push('/Home')}
        headerLeftClick={() => this.props.history.goBack()}
        backButton={true}
          
          back
        />
        <Container maxWidth='lg'>
      <div className='main-component'
       
      >
       
        <ScrollView style={styles.container}>
          {this.props.loading && (
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LoadingComponent styles={{width: 250, height: 250}} />
            </View>
          )}
          {this.props.error && (
            <View
              style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <Text style={{ fontWeight: "600", fontSize: 16 }}>
                {typeof this.props.errInfo === "string"
                  ? this.props.errInfo
                  : "something went wrong..."}
              </Text>
            </View>
          )}

          {courseInfo && Object.keys(courseInfo).length > 0 ? (

            <>
              <MaterialAndTestSeriesComponent
                  imageUrl={course_image}
                  id={id}
                  courseName={course_name}
                  duration={duration}
                  ratings={admin_rating}
                  isUserPaid={isUserPaid}
                  isFree={isFree}
                  discounted={is_discounted}
                  actualPrice={actual_price}
                  discountPrice={discount_price}
                  examName={this.state.examName}
                  makePayment={this.makePayment}
                          

                />
                <View style={{marginTop: 10}}>
                <View style={{flex:1, marginHorizontal: 12}}>
                    <Text style={{fontSize: 20, fontWeight: '700',}}>Faculty</Text>
                </View>
              </View> 
              <View style={styles.facultyInfo}>
                <View
                      style={{
                        width: 54,
                        height: 54,
                        borderRadius: 10,
                        borderWidth: 3,
                        marginTop: 10,
                        // marginBottom: -12,
                        borderColor: '#fff',
                        overflow: 'hidden'
                    }}
                >
                    <Image 
                        source={{uri: facultyInfo.profile_pic}}
                        style={{
                            width: '100%',
                            height: '100%',                                                              
                        }}
                        resizeMode='contain'
                    />
                </View>
                
                <View style={{flexDirection: 'column', marginHorizontal: 15, marginTop: 5, justifyContent: 'flex-start', flex: 1, alignSelf: 'flex-start'}}>
                    <Text style={{fontSize: 18, fontWeight: '700', color: '#000', }}> {facultyInfo && facultyInfo.first_name + " " + facultyInfo.last_name}</Text>
                    <Text style={{fontSize: 12, fontWeight: '500', color: 'rgba(0,0,0,0.6)', }}> {facultyInfo.experiance} {' '}Years Experience</Text>
                </View>
                </View>
              {/* <Surface style={styles.courseWrapper}>
                <View style={styles.courseInfo}>
                  <Image
                    style={styles.imageView}
                    source={{ uri: course_image }}
                    resizeMode={`${width <=780 ? 'cover': 'contain'}`}
                  />
                  <View style={styles.courseHeader}>
                    <Text style={styles.courseExam}>{this.state.examName}</Text>
                    <Text
                      style={[styles.courseTitle, { width: 210 }]}
                      ellipsizeMode="tail"
                      numberOfLines={2}
                    >
                      {course_name}
                    </Text>
                    <Text
                      style={[
                        styles.courseTitle,
                        { width: 210, fontSize: 12, marginTop: 6 },
                      ]}
                      ellipsizeMode="tail"
                      numberOfLines={1}
                    >
                      Duration: {duration} MONTHS
                    </Text>
                    <View style={{flexDirection: 'row', flex: 1, marginTop: 4, justifyContent: width <= 400 ? '' : 'space-between', alignItems: width <= 400 ? 'center' : 'flex-start', height: 0,}}>
                      <Text style={{fontSize: 13, color: Styles.primaryColor, marginTop: 10,}}>No of Faculties :  01 </Text>
                      <Avatar.Image size={32}
                      // source={{uri:profile_pic}} 
                      source={{uri: this.props.facultyAvatar || 'https://analog-ias.el.r.appspot.com/assets/dashboard/images/avatar-1.png'}} 
                      style={{backgroundColor: '#fff',marginRight: 15, }}
                      color={'#ccc'}
                      />
                  </View>
                    <View style={styles.ratings}>
                      <RatingsComponent ratings={admin_rating} />
                    </View>
                  </View>
                </View>
                { Config.coursePaymentButton && !isUserPaid && !isFree && (
                  <View style={styles.priceInfo}>
                    <View style={styles.price}>
                      {!is_discounted ? (
                        <Text
                          style={styles.actualPrice}
                        >{`₹ ${actual_price}`}</Text>
                      ) : null}
                      {is_discounted ? (
                        <Text
                          style={styles.actualPrice}
                        >{`₹ ${discount_price}`}</Text>
                      ) : null}
                      {is_discounted ? (
                        <Text
                          style={styles.strickedPrice}
                        >{`₹ ${actual_price}`}</Text>
                      ) : null}
                    </View>
                    <TouchableOpacity
                      onPress={() => {
                     
                       
                            this.props.history.push("/Payment", {
                              paymentInfo: {
                                transactionType: FOR_COURSE,
                                courseId: id,
                                price: is_discounted
                                  ? discount_price
                                  : actual_price,
                                appStoreProductId: app_store_product_id,
                              },
                              examId: this.state.examId,
                            });
                          
                        
                      }}
                      style={styles.buyNowBtn}
                    >
                      <Text style={styles.buyNowBtnText}>BUY NOW</Text>
                    </TouchableOpacity>
                  </View>
                )}
              </Surface> */}

 

              <View style={{ marginVertical: 12 }}>
                <Text style={styles.headerText}>Lessons</Text>
              </View>
              {!this.props.loading &&
                !(lessonPlanners && lessonPlanners.length > 0) && (
                  <View style={styles.noLessonsStyle}>
                    <Text style={styles.noLessonsText}>
                      Will be updated soon
                    </Text>
                  </View>
                )}
              <View style={{
                 paddingBottom: this.state.isAdShow ? 60 : 0,
                 flexDirection: 'row',
                 justifyContent: 'space-between',
                 alignItems: 'center',
                 flexWrap: 'wrap',
                 width: '100%'
              
              
              }}>
                {lessonPlanners &&
                  lessonPlanners.length > 0 &&
                   lessonPlanners.map((lesson, index) => {
                    const {
                      lesson_planner_name,
                      material_pdf_count_count,
                      material_video_count_count,
                      material_epub_count_count,
                      material_test_count_count,
                      id
                    } = lesson;
                    const title = lesson_planner_name;
                    const pdfCount = material_pdf_count_count;
                    const videoCount = material_video_count_count;
                    const epubCount = material_epub_count_count;
                    const testCount = material_test_count_count;
                    let isBookmarked = ids && ids[id];
                    const bookmark = bookmarks.find(c => c.content_id ===id);
                  
                    return (
                      <LessonComponent
                        // navigation={this.props.navigation}
                        history={this.props.history}
                        key={index}
                        title={title}
                        pdfCount={pdfCount}
                        videoCount={videoCount}
                        epubCount={epubCount}
                        testCount={testCount}
                        isUserPaid={isUserPaid}
                        isFree={isFree}
                        lessonPlannerId={id}
                        lesson={lesson}
                        mentor_name={mentor_name}
                        // addBookMarks={this.addBookMark}
                        // deleteBookMark={() => this.props.deleteBookMark(bookmark?.id)}
                        // isBookmarked={isBookmarked}
                        // bookmarkId={bookmark?.id}
                        facultyInfo={{
                            facultyId,
                            facultyAvatar,
                            facultyFirstName,
                        }}
                      />
                    );
                  })}
              </View>
            </>
          ) : null}
        </ScrollView>

        <View>
          {/* <AdsScreen screenName={'LessonPlannerScreen'} isAdCallBack={this.isAd}/> */}
        </View>
      </div>
      </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    isUserPaid,
    facultyInfo,
    lessonPlanners,
    courseInfo,
    isFree,
  } = lessonPlannerInfo(state);
  const bookmarkInfo = bookmarksSelector(state.allBookMarks);
  const addBookMarkResponse =  state?.addBookMark?.response?.bookmark;
  const deleteBookMarkInfo = state?.deleteBookMark?.response?.status === 'Success';
  const addBookMarkLoading = state?.addBookMark?.loading;
  return {
    loading: state.lessonPlanner && state.lessonPlanner.loading,
    error: state.lessonPlanner && state.lessonPlanner.error,
    errInfo:
      state.lessonPlanner &&
      state.lessonPlanner.errInfo &&
      state.lessonPlanner.errInfo.data &&
      state.lessonPlanner.errInfo.data.message,
    isUserPaid,
    facultyInfo,
    lessonPlanners,
    courseInfo,
    isFree,
    mentor_name: facultyInfo?.mentor_name,
    facultyId: facultyInfo?.id,
    facultyAvatar: facultyInfo?.profile_pic,
    facultyFirstName: facultyInfo?.first_name,
    bookmarkInfo,
    addBookMarkResponse,
    deleteBookMarkInfo,
    addBookMarkLoading,
    courseMaterial: bookmarkInfo?.courseMaterial,
  };
};

export default connect(mapStateToProps, {
  getLessonPlanner,
  clearLessonPlannerData,
  getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark
})(LessonPlanner);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 8,
  },
  courseWrapper: {
    padding: 8,
    paddingBottom: 0,
    borderRadius: 10,
    //   height: 80,
    // width: width - 20,
    //   alignItems: 'center',
    //   justifyContent: 'center',
    elevation: 8,
    borderTopColor: Styles.dangerColor,
    borderTopWidth: 10,
    
  },
  imageView: {
    width: width / 2.5 - 16,
    height: width<= 479 ? 100 : 200,
    borderRadius: 3,
    // borderBottomLeftRadius: 0,
    // borderBottomRightRadius: 0,
    marginBottom: 10,
    
  },
  courseInfo: {
    flexDirection: "row",
  },
  courseExam: {
    fontSize: 12,
    fontWeight: "500",
    color: "rgba(0,0,0,0.7)",
    marginBottom: 6,
  },
  courseTitle: {
    fontSize:width <= 400 ? 16 : 25,
    fontWeight: "600",
    
  },
  priceInfo: {
    flexDirection: "row",
    marginTop: 6,
  },
  courseHeader: {
    marginLeft: 8,
  },
  buyNowBtn: {
    // flexDirection: 'row',
    borderBottomRightRadius: 8,
    width: "50%",
    flex: 1,
    marginRight: -8,
    backgroundColor: Styles.primaryColor,
    paddingVertical: 12,
    cursor: 'pointer',
  },
  buyNowBtnText: {
    textAlign: "center",
    color: "#fff",
  },
  ratings: {
    // borderWidth: 3,
    marginTop: "auto",
    marginBottom: 15,
  },
  price: {
    width: "50%",
    justifyContent: "center",
    // borderWidth: 1,
    display: "flex",
    alignItems: "center",
  },
  strickedPrice: {
    textDecorationColor: "red",
    textDecorationLine: "line-through",
    fontWeight: "500",
    fontSize: 11,
  },
  actualPrice: {
    fontSize: 16,
    fontWeight: "600",
  },
  header: {
    marginTop: 32,
  },
  facultyWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 16,
    borderRadius: 8,
    marginVertical: 12,
    elevation: 8,
  },
  facultyDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  yearsOfExp: {
    fontSize: 11,
  },
  facultyInfo: {
    flexDirection: 'row',
    paddingHorizontal: 12, 
    height: 60,
    width: width <= 579 ? Math.floor(width - 60) : Math.floor(width/ 3),
    // position: 'relative',
    // paddingVertical: 12,
    marginBottom: 12,
    borderRadius: 10,
    borderWidth: 3,
    marginHorizontal: 10,
    borderColor: '#fff',
    marginTop: 10,  
   
},
  lessonWrapper: {
    flexDirection: 'row',
    paddingHorizontal: 12, 
    paddingVertical: 12,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '45%',
    borderRadius: 10,
    marginBottom: 12,
    borderWidth: 3,
    marginHorizontal: 10,
    borderColor: '#fff',
  },
  lessonHeader: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flex: 1,
  },
  headerText: {
    fontSize: 16,
    fontWeight: "500",
    color: "rgba(0,0,0,0.7)",
  },
  contentCountWrapper: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 5,
  },
  contentIcon: {
    marginRight: 5,
    width: 16, 
    height: 16
},
  contentCount: {
    fontSize: 14,
    color: "rgba(0,0,0,0.75)",
    textTransform: "capitalize",
    fontWeight: "600",
  },
  contentCounter: {
    flexDirection: 'row',
    justifyContent:'flex-start',
    alignItems: 'center',
    // borderWidth: 1,
    paddingTop: 10,
    width: '100%',
    flexWrap: 'wrap'
  },
  viewMore: {
    width: 75,
    height: 25,

    backgroundColor: Styles.primaryColor,
    flexDirection: "row",

    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    elevation: 5,
    paddingHorizontal: 5,
    paddingVertical: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonViewText: {
    fontSize: 11,
    color: "#fff",
  },
  noLessonsStyle: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  noLessonsText: {
    fontFamily: Styles.primaryFontFamily,
    fontSize: 18,
  },
});
